import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { AiOutlineEdit } from 'react-icons/ai';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Chip from '@mui/material/Chip';
import Text from '../../Text';
import Select from '../../Select';
import Checkbox from '../../Checkbox';


const Section = ( { title, body, e, picklists, contacts } ) => {
    const [ expanded, setExpanded ] = useState( false );
    
    useEffect( () => {
        setExpanded( body.length > 0 );
    }, [ body ] );

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    const renderDataType = ( field ) => {
        let el = null;

        switch ( field.type ) {
            case 'text':
            case 'date':
            case 'email':
            case 'phone':
            case 'url':
            case 'textarea':
                el = <Text key={field.db} label={field.label} db={field.db} value={e[field.db]} />;
                break;

            case 'select':
                el = <Select key={field.db} label={field.label} db={field.db} value={e[field.db]} options={picklists} />;
                break;

            case 'checkbox':
                el = <Checkbox key={field.db} label={field.label} db={field.db} value={e[field.db]} />;
                break;

            case 'contact':
                const rid = contacts.find( f => f.cid === e[field.db] );
                el = (
                    <Col>
                        <Row>
                            <Col key={field.db} className='col-md-auto p-0 fw-light'>{field.label}</Col>
                            {
                                rid ? (
                                    <Col className='tf-form-text-field me-1'><Link to={`/contact/${rid.cid}`}>{rid.firstname} {rid.lastname}</Link></Col>
                                ) : (
                                    null
                                )
                            }
                        </Row>
                    </Col>
                );
                break;

            default:
                if ( field.db ) {
                    el = <Col key={field.db}>{field.label}: {e[field.db]}</Col>;
                } else {
                    el = <Col key={Math.random()}>&nbsp;</Col>;
                }
        }
        
        return el;
    }

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>{title}</Typography></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush'>
                    {
                        body.map( ( b, idx ) => {
                            if ( b.length ) {
                                return (
                                    <ListGroup.Item key={idx} className='border-0 py-0'>
                                        <Row className='align-items-center'>
                                            {
                                                b.map( ( field ) => ( renderDataType( field ) ) )
                                            }
                                        </Row>
                                    </ListGroup.Item>
                                )
                            }
                            return <ListGroup.Item key={idx} className='border-0 py-0'><Row className='align-items-center'><Col>&nbsp;</Col></Row></ListGroup.Item>;
                        } )
                    }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    // e: state.events.current.details,
    picklists: state.user.meta.event.picklist,
    contacts: state.user.lists.contacts
} );

const mapDispatch = ( dispatch ) => ( {
    // loadTasks: dispatch.contacts.loadContactTasks,
} );

export default connect( mapProps, mapDispatch )( Section );